(function() {
  'use strict';

  function setFutureDate(selector = '.top-btn-info__date', hoursAhead = 48) {
    let futureDate = new Date();
    let hoursAdded = 0;
  
    while (hoursAdded < hoursAhead) {
      futureDate.setHours(futureDate.getHours() + 1);
      const day = futureDate.getDay();
      
      if (day !== 0 && day !== 6) {
        hoursAdded++;
      }
    }
  
    const options = {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    };
  
    const formatted = futureDate.toLocaleDateString('pt-BR', options)
      .replace('.', '') 
      .replace(/^./, str => str.toUpperCase()); 
  
    const el = document.querySelector(selector);
    if (el) el.textContent = formatted;
  
    return formatted;
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    setFutureDate();
  });

  

// ---------------------------
// Словарь соответствия английских названий городов Португалии португальским
// ---------------------------
const cityTranslations = {
  "lisbon": "Lisboa",
  "porto": "Porto",
  "amadora": "Amadora",
  "braga": "Braga",
  "setubal": "Setúbal",
  "coimbra": "Coimbra",
  "queluz": "Queluz",
  "funchal": "Funchal",
  "cacem": "Cacém",
  "vila nova de gaia": "Vila Nova de Gaia",
  "loures": "Loures",
  "aveiro": "Aveiro",
  "barreiro": "Barreiro",
  "rio tinto": "Rio Tinto",
  "vila real": "Vila Real",
  "guimaraes": "Guimarães",
  "leiria": "Leiria",
  "ponta delgada": "Ponta Delgada",
  "faro": "Faro",
  "evora": "Évora",
  "braganca": "Bragança",
  "beja": "Beja",
  "guarda": "Guarda",
  "cascais": "Cascais",
  "sintra": "Sintra",
  "viana do castelo": "Viana do Castelo",
  "viseu": "Viseu",
  "tomar": "Tomar",
  "obidos": "Óbidos",
  "tavira": "Tavira",
  "lagos": "Lagos",
  "albufeira": "Albufeira",
  "portimao": "Portimão",
  "olhao": "Olhão",
  "seixal": "Seixal",
  "matosinhos": "Matosinhos",
  "vila franca de xira": "Vila Franca de Xira",
  "amarante": "Amarante",
  "fafe": "Fafe",
  "penafiel": "Penafiel",
  "vila do conde": "Vila do Conde",
  "espinho": "Espinho",
  "santarem": "Santarém",
  "vila nova de famalicão": "Vila Nova de Famalicão",
  "torres vedras": "Torres Vedras",
  "mafra": "Mafra",
  "elvas": "Elvas",
  "covilha": "Covilhã",
  "chaves": "Chaves",
  "sines": "Sines",
  "vila real de santo antonio": "Vila Real de Santo António",
  "montijo": "Montijo",
  "almada": "Almada",
  "odivelas": "Odivelas",
  "povoa de varzim": "Póvoa de Varzim",
  "ilhavo": "Ílhavo",
  "moura": "Moura",
  "ourem": "Ourém",
  "castelo branco": "Castelo Branco",
  "caldas da rainha": "Caldas da Rainha",
  "moita": "Moita",
  "santa maria da feira": "Santa Maria da Feira",
  "vila pouca de aguiar": "Vila Pouca de Aguiar",
  "vendas novas": "Vendas Novas",
  "loule": "Loulé",
  "vila verde": "Vila Verde",
  "vila nova de santo andre": "Vila Nova de Santo André",
  "oliveira de azemeis": "Oliveira de Azeméis",
  "vila nova de cerveira": "Vila Nova de Cerveira",
  "montalegre": "Montalegre",
  "monchique": "Monchique",
  "gondomar": "Gondomar",
  "seia": "Seia",
  "amora": "Amora",
  "felgueiras": "Felgueiras",
  "silves": "Silves",
  "portalegre": "Portalegre",
  "figueira da foz": "Figueira da Foz",
  "castelo de paiva": "Castelo de Paiva",
  "agueda": "Águeda",
  "aljustrel": "Aljustrel",
  "esposende": "Esposende",
  "viana do alentejo": "Viana do Alentejo",
  "vila do bispo": "Vila do Bispo",
  "borba": "Borba",
  "castro verde": "Castro Verde",
  "alenquer": "Alenquer",
  "serta": "Sertã",
  "vila nova de paiva": "Vila Nova de Paiva",
  "carregal do sal": "Carregal do Sal",
  "vila velha de rodão": "Vila Velha de Ródão",
  "pombal": "Pombal",
  "lamego": "Lamego",
  "peso da regua": "Peso da Régua",
  "sever do vouga": "Sever do Vouga",
  "santa comba dao": "Santa Comba Dão",
  "mangualde": "Mangualde",
  "reguengos de monsaraz": "Reguengos de Monsaraz",
  "estremoz": "Estremoz",
  "alcacer do sal": "Alcácer do Sal",
  "almodovar": "Almodôvar",
  "castro marim": "Castro Marim",
  "caminha": "Caminha",
  "celorico de basto": "Celorico de Basto",
  "vila de rei": "Vila de Rei",
  "almeida": "Almeida",
  "satao": "Sátão",
  "nelas": "Nelas",
  "alpiarca": "Alpiarça",
  "alandroal": "Alandroal",
  "carrazeda de ansiaes": "Carrazeda de Ansiães",
  "vila nova da barquinha": "Vila Nova da Barquinha",
  "vila nova de foz coa": "Vila Nova de Foz Côa",
  "porto de mos": "Porto de Mós",
  "tabua": "Tábua",
  "vila franca do campo": "Vila Franca do Campo",
  "vila vicosa": "Vila Viçosa",
  "odemira": "Odemira",
  "ourique": "Ourique",
  "serpa": "Serpa",
  "ponte de sor": "Ponte de Sor",
  "redondo": "Redondo",
  "alcobaca": "Alcobaça",
  "arronches": "Arronches",
  "vila nova de poiares": "Vila Nova de Poiares",
  "sabrosa": "Sabrosa",
  "aljezur": "Aljezur",
  "peniche": "Peniche",
  "moimenta da beira": "Moimenta da Beira",
  "mirandela": "Mirandela",
  "vila flor": "Vila Flor",
  "oleiros": "Oleiros",
  "castelo de vide": "Castelo de Vide",
  "fundao": "Fundão",
  "cabeceiras de basto": "Cabeceiras de Basto"
};

const appsScriptUrl = 'https://script.google.com/macros/s/AKfycbyu1V62AZGoQIGFDgtsriiPk8mvhZJWxayqrF-Mns8FFgUbLzSUZvYSvXRRQ1jyah_c/exec';

// ---------------------------
// Основной код определения города
// ---------------------------
const USE_BROWSER_GEOLOCATION = false; // true — включить браузерную геолокацию

document.addEventListener('DOMContentLoaded', function () {
  getUserCity();
});

function getUserCity() {
  if (USE_BROWSER_GEOLOCATION && 'geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      pos => resolveCityName(pos.coords.latitude, pos.coords.longitude),
      () => getLocationCityFallback(),
      { timeout: 5000 }
    );
  } else {
    getLocationCityFallback();
  }
}

function resolveCityName(lat, lon) {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=10&addressdetails=1&accept-language=pt`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      let city = data.address.city || data.address.town || data.address.village || data.address.state || '';
      processCity(city);
    })
    .catch(() => getLocationCityFallback());
}

// Резервное определение по IP
const ipLocationProviders = [
  'https://ipwho.is/'
];

function getLocationCityFallback(providerIndex = 0) {
  if (providerIndex >= ipLocationProviders.length) {
    updateCityInDOM(null);
    return;
  }

  fetch(ipLocationProviders[providerIndex])
    .then(res => res.json())
    .then(data => {
      let city = (data.city || data.region || '').toLowerCase();
      processCity(city);
    })
    .catch(() => getLocationCityFallback(providerIndex + 1));
}

function processCity(rawCity) {
  if (!rawCity) {
    updateCityInDOM('');
    return;
  }
  const cityKey = rawCity.toLowerCase();
  const cityPT = cityTranslations[cityKey] || rawCity;
  updateCityInDOM(cityPT);
}

  function updateCityInDOM(cityName) {
    const elems = document.querySelectorAll('.js-city');
    elems.forEach(el => {
      if (el) {
        el.textContent = cityName;
      }
    });      
  }
  
  document.addEventListener('DOMContentLoaded', function () {
    getUserCity();
  });


  
  // get season
  function getSeason() {
    const seasonElement = document.querySelector('.js-season');
    if (!seasonElement) return;

    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();

    let season = '';

    if ((month === 3 && day >= 21) || (month > 3 && month < 6) || (month === 6 && day <= 20)) {
        season = 'Primavera';
    } else if ((month === 6 && day >= 21) || (month > 6 && month < 9) || (month === 9 && day <= 20)) {
        season = 'Verão'; 
    } else if ((month === 9 && day >= 21) || (month > 9 && month < 12) || (month === 12 && day <= 20)) {
        season = 'Outono';
    } else {
        season = 'Inverno';
    }

    seasonElement.textContent = `Promoção de ${season}`;
  }

  // get season checkout
  function getSeasonCheckout() {
    const seasonElement = document.querySelector('.js-season-checkout');
    if (!seasonElement) return;

    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();

    let season = '';
    let iconHTML = '';

    if ((month === 3 && day >= 21) || (month > 3 && month < 6) || (month === 6 && day <= 20)) {
      season = 'Primavera';
      iconHTML = '🌸';
    } else if ((month === 6 && day >= 21) || (month > 6 && month < 9) || (month === 9 && day <= 20)) {
      season = 'Verão'; 
      iconHTML = '☀️';
    } else if ((month === 9 && day >= 21) || (month > 9 && month < 12) || (month === 12 && day <= 20)) {
      season = 'Outono';
      iconHTML = '🍁';
    } else {
      season = 'Inverno'; 
      iconHTML = '❄️';
    }

    seasonElement.innerHTML = `${iconHTML} VENDA DE ${season}`;
  }  

  // show deal
  function showDeal() {
    const target = document.querySelector('.try-content--1');
    const deal = document.querySelector('.try-deal');

    if (!target || !deal) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                deal.classList.add('is-active');
            } else {
                deal.classList.remove('is-active');
            }
        });
    });

    observer.observe(target);
  }  

  // auto click cart to checkout
  function autoClickToCheckout() {
    if (window.location.href.includes('/cart')) {   
      const checkoutButton = document.getElementById('checkout');
      if (checkoutButton) {
        console.log(checkoutButton);
        checkoutButton.click();
      }
    }    
  }    

  // fetch user's geolocation data
  function getgGeoShipping() {
    const freeShipping = document.querySelector('.c-product__free-shipping');
    if (!freeShipping) return;
    
    fetch('https://get.geojs.io/v1/ip/geo.json')
      .then(response => response.json())
      .then(data => {
        const country = data.country;
        const countryCode = data.country_code.toLowerCase();
        
        // Update the country name
        document.querySelector('.js-shipping-country').textContent = 'Portugal';

        // Update the flag
        const flagElement = document.querySelector('.c-product__free-shipping-flag');
        flagElement.src = `https://flagcdn.com/w40/pt.png`;
        flagElement.alt = countryCode;
      })
      .catch(error => {
        console.error('Error fetching geolocation data:', error);
        // Fallback to default values
        document.querySelector('.js-shipping-country').textContent = 'Portugal';
        const flagElement = document.querySelector('.c-product__free-shipping-flag');
        flagElement.src = `https://flagcdn.com/w40/pt.png`;
      });
  }

  // countdown
  function initializeCountdown(selector, durationMinutes, onExpireMessage = "EXPIRADO") {
    const countdownElements = document.querySelectorAll(selector);
    if(!countdownElements) return;
  
    countdownElements.forEach(element => {
        let remainingTime = durationMinutes * 60;
    
        function formatTime(seconds) {
          const minutes = Math.floor(seconds / 60);
          const secs = seconds % 60;
          return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
    
        element.textContent = formatTime(remainingTime);
    
        const timerInterval = setInterval(() => {
          remainingTime -= 1;
    
          if (remainingTime > 0) {
            element.textContent = formatTime(remainingTime);
          } else {
            clearInterval(timerInterval);
            element.textContent = onExpireMessage;
          }
        }, 1000);
      });
  } 

  // global variable
  const TAX_RATE = 0.23;
  const additionalProductPrice = 9.95;   

  // calc tax
  function calculateTax(basePrice, taxRate) {
    return basePrice * taxRate;
  }

  // clear cart
  async function clearCart() {
      try {
          const response = await fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              }
          });
          if (!response.ok) {
              throw new Error('Error clearing cart');
          }
          const data = await response.json();
          console.log('Cart cleared:', data);
          return data;
      } catch (error) {
          console.error('Error clearing cart:', error);
          throw error;
      }
  }  

  // add product to cart
  async function addProductToCart(variantId) {
      try {        
          const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  /*properties: {
                    'total_price_with_tax': priceWithTax.toFixed(2),
                  },*/
              }),
          });
          if (!response.ok) {
              throw new Error('Error adding product to cart');
          }
          const data = await response.json();
          console.log('Product added to cart:', data);
          return data;
      } catch (error) {
          console.error('Error adding product to cart:', error);
          //alert('Error adding product to cart');
          throw error;
      }
  }

  // remove product from cart
  async function removeProductFromCart(variantId) {
      try {
          const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  id: variantId,
                  quantity: 0, 
              }),
          });
  
          if (!response.ok) {
              throw new Error('Error removing product from cart');
          }
  
          const data = await response.json();
          console.log('Product removed from cart:', data);
          return data;
      } catch (error) {
          console.error('Error removing product from cart:', error);
          throw error;
      }
  }  

  /*function getDiscountCodeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('discount');
  }

  function getDiscountPercent(code) {
    switch (code?.toUpperCase()) {
      case 'POUPANÇA25':
      case 'POUPANCA25':
        return 25;
      case 'JOELHEIRA5':
        return 5;
      default:
        return 0;
    }
  }

  const discountCode = getDiscountCodeFromUrl();
  const discountPercent = getDiscountPercent(discountCode);
  console.log('discountCode: ' + discountCode, 'discountPercent: ' + discountPercent);*/

  // update total price
  function updateTotalPrice(checkbox, totalPriceElements, taxRate) {
      const basePriceElements = document.querySelectorAll('.js-product-price');
      if (!basePriceElements || basePriceElements.length === 0 || !totalPriceElements || totalPriceElements.length === 0) return;
  
      let basePrice = 0;
  
      basePriceElements.forEach(el => {
        basePrice += parseFloat(el.textContent.replace(/[€$]/g, '').trim().replace(',', '.'));
        // basePrice += parseFloat(el.textContent.replace(/[€$]/g, '').trim());
      });
     
      // if (checkbox.checked) {
      //     basePrice += additionalProductPrice;
      // }

      const selectedOption = document.querySelector('.c-product__option-control:checked');
      const summaryFreeShip = document.querySelector('.c-order-summary__free-ship');    

      //let additionalDeliveryPrice = 0;

    // All products have free shipping
    const free_shipping = true;

    if ( free_shipping ) {
      summaryFreeShip.textContent = '+Envio GRÁTIS';
    } else if (selectedOption) {
        if (selectedOption.value === "49715309805889") {         
          summaryFreeShip.textContent = '+ €5 Envio';        
          basePrice += 5;
        } else if (selectedOption.value === "49715309773121") {
          summaryFreeShip.textContent = '+ €4,45 ENVIO';
          basePrice += 4.45;
        } else {
          summaryFreeShip.textContent = '+Envio GRÁTIS';
        }
    }  

      const taxAmount = calculateTax(basePrice, taxRate);
      const totalPrice = basePrice + taxAmount;
  
      totalPriceElements.forEach(el => {
        el.textContent = `€${totalPrice.toFixed(2).replace('.', ',')}`;
      });           

      const taxElement = document.querySelector('.js-product-tax');
      if (taxElement) {
        taxElement.textContent = `€${taxAmount.toFixed(2).replace('.', ',')}`;
      }
  }    

  
  // init product  
  function initProduct() {
      const productOptions = document.querySelectorAll('.c-product__option');
      if (!productOptions) return;

      let previousVariantId = null;
      let isCheckboxChecked = false;
      let taxAmount = 0;

      // const checkbox = document.querySelector('.c-product-add__control');
      // if (checkbox) {
      //     checkbox.addEventListener('change', async function () {
      //         isCheckboxChecked = checkbox.checked;
      //         if (checkbox.checked) {
      //             await addProductToCart('49743083209025');
      //         } else {
      //             await removeProductFromCart('49743083209025');
      //         }
      //     });
      // }      
    
      productOptions.forEach(option => {
          const discountPercentElement = option.querySelector('.js-discout-percent');
          if (!discountPercentElement) return;
        
          const variantPrice = option.querySelector('input[name="Quantidade-1"]').getAttribute('data-variant-price');
          const variantPriceOld = option.querySelector('input[name="Quantidade-1"]').getAttribute('data-variant-price-old');
  
          if (discountPercentElement && variantPriceOld) {
              const oldPrice = parseFloat(variantPriceOld.replace('€', '').trim().replace(',', '.'));
              const currentPrice = parseFloat(variantPrice.replace('€', '').trim().replace(',', '.'));
              //  const oldPrice = parseFloat(variantPriceOld.replace('€', '').trim());
              // const currentPrice = parseFloat(variantPrice.replace('€', '').trim());
  
              if (!isNaN(oldPrice) && !isNaN(currentPrice) && oldPrice > currentPrice) {
                  const discountPercent = Math.round(((oldPrice - currentPrice) / oldPrice) * 100);
                  discountPercentElement.textContent = `Poupe ${discountPercent}%`;
              } else {
                  discountPercentElement.textContent = '';
              }
          }
      });

    
      const radios = document.querySelectorAll('input[name="Quantidade-1"]');  
      if (!radios.length) return;
      
      radios.forEach(radio => {         
        
          radio.addEventListener('change', async function () {
              const variantId = this.value;
              const variantTitle = this.getAttribute('data-variant-title');
              const variantPrice = this.getAttribute('data-variant-price');
              const variantPriceOld = this.getAttribute('data-variant-price-old');
              const variantImage = this.getAttribute('data-variant-image');      
    
              const productImage = document.getElementById('product-image');
              if (productImage) {
                  productImage.src = variantImage; 
              }
  
              const productTitles = document.querySelectorAll('.js-product-variant');
              if (productTitles) {
                  productTitles.forEach(el => el.textContent = variantTitle.replace('x', ''));
              }              
  
              const productPrices = document.querySelectorAll('.js-product-price');
              if (productPrices) {
                  productPrices.forEach(el => el.textContent = variantPrice);
              }
  
              const productOldPrices = document.querySelectorAll('.js-product-price-old');
              if (productOldPrices) {
                  productOldPrices.forEach(el => el.textContent = `Preço Habitual ${variantPriceOld}`);
              }    
  
              const productPricePerItems = document.querySelectorAll('.c-order-summary__price-per-item');   
              if (productPricePerItems) {
                  const countValue = variantTitle.match(/\d+/) ? parseInt(variantTitle.match(/\d+/)[0]) : 1;
                  const numericPrice = parseFloat(variantPrice.replace(/[€$]/g, '').trim().replace(',', '.'));
                  // const numericPrice = parseFloat(variantPrice.replace(/[€$]/g, '').trim());
              
                  if (countValue > 0) {
                      const unitPrice = numericPrice / countValue;                        
                      if (countValue === 1) {
                          productPricePerItems.forEach(el => el.textContent = `Apenas €${unitPrice.toFixed(2).replace('.', ',')}`);
                      } else {
                          productPricePerItems.forEach(el => el.textContent = `€${unitPrice.toFixed(2).replace('.', ',')} cada`);
                      }
                  }      
              }              

              /*const orderSummaryDiscoutPercents = document.querySelectorAll('.c-order-summary__discout-percent');
              if (orderSummaryDiscoutPercents && variantPriceOld) {
                  const oldPrice = parseFloat(variantPriceOld.replace(/[€$]/g, '').trim().replace(',', '.'));
                  const currentPrice = parseFloat(variantPrice.replace(/[€$]/g, '').trim().replace(',', '.'));
  
                  if (!isNaN(oldPrice) && !isNaN(currentPrice) && oldPrice > currentPrice) {
                      const discountPercent = Math.round(((oldPrice - currentPrice) / oldPrice) * 100);
                      orderSummaryDiscoutPercents.forEach(el => el.textContent = `Poupe ${discountPercent}%`);
                  } else {
                      orderSummaryDiscoutPercents.forEach(el => el.textContent = '');
                  }
              }  */   

              const discountPercentElement = radio.closest('.c-product__option').querySelector('.c-product__option-discout-percent');
              if (discountPercentElement) {
                  const discountPercentText = discountPercentElement.textContent;
                  const discountPercent = discountPercentText.match(/\d+/); 
                  if (discountPercent) {
                      const discount = discountPercent[0]; 
                      const orderSummaryDiscoutPercents = document.querySelectorAll('.c-order-summary__discout-percent');
                      if (orderSummaryDiscoutPercents) {
                          orderSummaryDiscoutPercents.forEach(el => el.textContent = `Poupe ${discount}%`);
                      }
                  }
              }

              

              if (variantId !== previousVariantId) {         
                try {
                    const orderSummaryButton = document?.querySelector('.c-order-summary__btn');
                    if (orderSummaryButton) {
                        orderSummaryButton.classList.add('is-disabled'); 
                    }
                  
                    await clearCart();
                    await addProductToCart(variantId); 

                    // if (checkbox && isCheckboxChecked) {
                    //     await addProductToCart('49743083209025');
                    // }
  
                    updateTotalPrice(document.querySelector('.c-product-add__control'), document.querySelectorAll('.js-product-total-price'), TAX_RATE);
                  
                    if (orderSummaryButton) {
                      orderSummaryButton.classList.remove('is-disabled');
                    }
                  
                } catch (error) {
                    console.error('Error processing cart actions:', error);
                }
              }

              // if (checkbox && isCheckboxChecked) {
              //   checkbox.checked = true;
              //   isCheckboxChecked = true;
              // }

              previousVariantId = variantId;
          });
      });
      
      let firstRadio = radios[0];
      if (firstRadio) {
          firstRadio.checked = true;
          firstRadio.dispatchEvent(new Event('change'));
      }
  }

  //  product count stock
  function initProductCountStock() {
      const productCountElement = document.querySelector('.c-product__count');
      if(!productCountElement) return;
    
      let productCount = 14;      
      const expiredMessage = 'EXPIRADO';
  
      function decrementProductStock() {
          if (productCount < 1) {
              productCountElement.textContent = expiredMessage;
              clearInterval(countdownInterval);
              return;
          }
  
          productCountElement.textContent = productCount;
          const decreaseBy = Math.floor(Math.random() * 2) + 1;  // Randomly decrease by 1 or 2
          productCount -= decreaseBy;
      }
  
      const countdownInterval = setInterval(decrementProductStock, 60000); // Update every minute
      decrementProductStock();
  }    

  // addition product  
  function initAdditionalProductCheckbox() {
      const checkbox = document.querySelector('.c-product-add__control'); 
      const orderSummaryItems = document.querySelector('.c-order-summary__items');
      const totalPriceElements = document.querySelectorAll('.js-product-total-price');
      if (!checkbox || !orderSummaryItems || !totalPriceElements) return;
    
      // const additionalProductVariantId = '49743083209025';      

      const additionalProductHtml = `
        <div class="c-order-summary__item" id="additional-product-summary">
            <div class="c-order-summary__pict">
                <img src="https://assets.checkoutchamp.com/9304c7c0-563a-11ee-8f2e-0115567b5690/1722712752960_10_bde17d08_1fd1_40f8_93b4_d51b454ef5b8_1080x_removebg_preview.png" alt="Patches de Alívio da Dor no Joelho" height="100" width="100">
            </div>
            <div class="c-order-summary__title">
                30x Patches de Alívio da Dor no Joelho
            </div>
            <div class="c-order-summary__content">       
                <div>€${additionalProductPrice}</div>
            </div>
        </div>
     `;            
  
      checkbox.addEventListener('change', async function () {
          try {
              if (this.checked) {
                  const orderSummaryButton = document?.querySelector('.c-order-summary__btn');
                  if (orderSummaryButton) {
                      orderSummaryButton.classList.add('is-disabled');
                  }
                
                  // console.log('Adding additional product to cart:', additionalProductVariantId);
                  // await addProductToCart(additionalProductVariantId);
                
                  if (!document.getElementById('additional-product-summary')) {
                      orderSummaryItems.insertAdjacentHTML('beforeend', additionalProductHtml);
                  }                  
                
                  console.log('Additional product added.');
                  
                  if (orderSummaryButton) {
                      orderSummaryButton.classList.remove('is-disabled'); 
                  }
                
              } else {
                  const orderSummaryButton = document?.querySelector('.c-order-summary__btn');
                  if (orderSummaryButton) {
                      orderSummaryButton.classList.add('is-disabled'); 
                  }
                
                  // console.log('Removing additional product from cart:', additionalProductVariantId);
                  // await removeProductFromCart(additionalProductVariantId);

                  const summaryItem = document.getElementById('additional-product-summary');
                  if (summaryItem) summaryItem.remove();                  
                
                  console.log('Additional product removed.');
                
                  if (orderSummaryButton) {
                      orderSummaryButton.classList.remove('is-disabled');
                  }
              }
            
              updateTotalPrice(checkbox, totalPriceElements, TAX_RATE); 
            
          } catch (error) {
              console.error('Error processing additional product:', error);
          }
      });
  }

  // toggle order summary
  function toggleOrderSummary() {   
    const summaryHead = document.querySelector('.c-order-summary__head');
    if (!summaryHead) return;
    const summaryBody = document.querySelector('.c-order-summary__body');
    const summaryText = summaryHead.querySelector('strong');

    if (summaryHead && summaryBody && summaryText) {
        summaryHead.addEventListener('click', function() {            
            summaryHead.classList.toggle('is-active');
            summaryBody.classList.toggle('is-hidden');

            if (summaryBody.classList.contains('is-hidden')) {
                summaryText.textContent = 'Resumo da Ordem de Costura';
            } else {
                summaryText.textContent = 'Ocultar Resumo do Pedido';
            }
        });
    }
  }

   function initCreateOrder () {
    const terms_service = document.getElementById('terms_service');
    const terms_service_label = document.getElementById('terms_service_label');
    terms_service?.addEventListener('click',  function () {
      terms_service_label.classList.remove('error_input');
    });
     
    document.getElementById('submit_order_OLD')?.addEventListener('click', async function () {
      const fields = document.querySelectorAll('.step_form_row input, .step_form_row select');
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      console.log(cartData);
      let hasError = false;
      let formData = {};
    
      fields.forEach(field => {
        const error = field.nextElementSibling;
    
        if (error && error.classList.contains('error-msg')) {
          error.remove();
          field.classList.remove('error_input');
        }


        if(!terms_service?.checked && terms_service_label) {
          terms_service_label.classList.add('error_input');
           hasError = true;
        }
        
    
        if (!field.value.trim() && field.dataset.error) {
          hasError = true;
          const errorMsg = field.dataset.error;
          const errorSpan = document.createElement('span');
          errorSpan.classList.add('error-msg');
          errorSpan.textContent = errorMsg;
          field.insertAdjacentElement('afterend',errorSpan);
          field.classList.add('error_input');
        } else {
          formData[field.name] = field.value.trim();
    
          const checkstate = field.dataset.checkstate;
          if(checkstate) {
          const selectedOption = field.options[field.selectedIndex];
    
            formData['state'] = selectedOption.dataset.state;
          }
        }
      });
    
        if (!hasError && cartData.items && cartData.items.length > 0) {
          const loading_order = document.getElementById('loading_order');
          const pendingDraft = localStorage.getItem("pendingDraft");

          loading_order.classList.remove('hidden');
           const selectedOption = document.querySelector('.c-product__option-control:checked');
            var shipping_price = "0.00";
            if (selectedOption && selectedOption.value === "49715309805889") {
              shipping_price = "5.00";
            }
            if (selectedOption && selectedOption.value === "49715309773121") {
              shipping_price = "4.45";
            }
                    
           formData['items'] = cartData.items;
          formData['shipping_price'] = shipping_price;
          formData['note'] = "Cobrança na entrega (COD)";
          formData['shipping_title'] = "CTT Expresso";
          formData['email'] = generateEmail(formData['lastName'],formData['phone']);
          formData['step_2'] = true;
          if(pendingDraft) {
            formData['id'] = pendingDraft;
          }


          // console.log('Form Data:', formData);
         
          // return;
          fetch('https://knee-lap-app-69bcb28b7052113be9cf.o2.myshopify.dev/create-orderv2', {
            method: 'POST',
            body: JSON.stringify(formData),
          })
          .then(res => res.json())
          .then(data => {
            // console.log(data);
            if(data.success) {
              localStorage.removeItem("pendingDraft");
              localStorage.removeItem("pendingDraftData");

              loading_order.classList.add('hidden');
              const draft_order = data.data.draft_order;
              console.log(draft_order)
              const lineItems = draft_order.line_items.map(item => ({
                    name: item.name,
                    quantity: item.quantity || 1,
                    price: item.price
                }));
              
              const thankyou_obj = {
                customer_name: draft_order.shipping_address.name,
                customer_name_2: draft_order.shipping_address.name,
                total_price: draft_order.total_price,
                final_value: draft_order.total_price,
                items: JSON.stringify(lineItems),
                sub_total_value: draft_order.subtotal_price,
                tax_value: draft_order.total_tax,
                shipping_value: shipping_price,
                customer_phone: draft_order.shipping_address.phone,
                customer_email: draft_order.email,
                customer_address:  draft_order.shipping_address.address1 + ', ' + draft_order.shipping_address.city + ', ' + draft_order.shipping_address.province + ', ' + draft_order.shipping_address.zip + ' ' + draft_order.shipping_address.country
              };

              const params = new URLSearchParams(thankyou_obj).toString();
              window.location.href = `/pages/thank-you?${params}`;
            }
            // location.href = location.href;
          })
          .catch(err => console.error(err));
          
          
        }
      });


document.getElementById('submit_order')?.addEventListener('click', async function () {
  const fields = document.querySelectorAll('.step_form_row input, .step_form_row select');
  const cartResponse = await fetch('/cart.js');
  const cartData = await cartResponse.json();

  console.log(cartData);
  let hasError = false;
  let formData = {};

  fields.forEach(field => {
    const error = field.nextElementSibling;

    if (error && error.classList.contains('error-msg')) {
      error.remove();
      field.classList.remove('error_input');
    }

    if(!terms_service?.checked && terms_service_label) {
      terms_service_label.classList.add('error_input');
      hasError = true;
    }

    if (!field.value.trim() && field.dataset.error) {
      hasError = true;
      const errorMsg = field.dataset.error;
      const errorSpan = document.createElement('span');
      errorSpan.classList.add('error-msg');
      errorSpan.textContent = errorMsg;
      field.insertAdjacentElement('afterend',errorSpan);
      field.classList.add('error_input');
    } else {
      formData[field.name] = field.value.trim();

      const checkstate = field.dataset.checkstate;
      if(checkstate) {
        const selectedOption = field.options[field.selectedIndex];
        formData['state'] = selectedOption.dataset.state;
      }
    }
  });

  if (!hasError && cartData.items && cartData.items.length > 0) {
    const loading_order = document.getElementById('loading_order');
    const pendingDraft = localStorage.getItem("pendingDraft");

    loading_order.classList.remove('hidden');
    
    const selectedOption = document.querySelector('.c-product__option-control:checked');
    var shipping_price = "0.00";
    // commented out as there is free shipping for all variants now
    // if (selectedOption && selectedOption.value === "49715309805889") {
    //   shipping_price = "5.00";
    // }
    // if (selectedOption && selectedOption.value === "49715309773121") {
    //   shipping_price = "4.45";
    // }
    
    // Get tax amount from the page
    const taxElement = document.querySelector('.js-product-tax');
    let tax_amount = "0.00";
    if (taxElement) {
      // Extract tax value: "€8,23" -> "8.23"
      const taxText = taxElement.textContent.trim();
      tax_amount = taxText.replace('€', '').replace(',', '.').trim();
    }
    
    // Calculate subtotal and total
    const subtotal = cartData.items.reduce((sum, item) => sum + (item.final_line_price / 100), 0);
    const total = subtotal + parseFloat(shipping_price) + parseFloat(tax_amount);
    
    formData['items'] = cartData.items;
    formData['shipping_price'] = shipping_price;
    formData['tax_amount'] = tax_amount;
    formData['note'] = "Cobrança na entrega (COD)";
    formData['shipping_title'] = "CTT Expresso";
    formData['email'] = generateEmail(formData['lastName'], formData['phone']);
    formData['step_2'] = true;
    
    if(pendingDraft) {
      formData['rowId'] = pendingDraft;
    }

    fetch(appsScriptUrl, {
      method: 'POST',
      body: JSON.stringify(formData),
    })
    .then(res => res.json())
    .then(data => {
      if(data.status === 'success') {
        localStorage.removeItem("pendingDraft");
        localStorage.removeItem("pendingDraftData");

        loading_order.classList.add('hidden');
        
        // Construct draft_order object from our data
        const lineItems = cartData.items.map(item => ({
          name: item.product_title + (item.variant_title ? ' - ' + item.variant_title : ''),
          quantity: item.quantity || 1,
          price: (item.final_price / 100).toFixed(2)
        }));
        
        const draft_order = {
          line_items: lineItems,
          shipping_address: {
            name: formData.firstName + ' ' + formData.lastName,
            address1: formData.address,
            city: formData.city,
            province: formData.state,
            zip: formData.zip,
            country: formData.country,
            phone: formData.phone
          },
          email: formData.email,
          subtotal_price: subtotal.toFixed(2),
          total_tax: tax_amount,
          total_price: total.toFixed(2)
        };
        
        const thankyou_obj = {
          customer_name: draft_order.shipping_address.name,
          customer_name_2: draft_order.shipping_address.name,
          total_price: draft_order.total_price,
          final_value: draft_order.total_price,
          items: JSON.stringify(lineItems),
          sub_total_value: draft_order.subtotal_price,
          tax_value: draft_order.total_tax,
          shipping_value: shipping_price,
          customer_phone: draft_order.shipping_address.phone,
          customer_email: draft_order.email,
          customer_address: draft_order.shipping_address.address1 + ', ' + draft_order.shipping_address.city + ', ' + draft_order.shipping_address.province + ', ' + draft_order.shipping_address.zip + ' ' + draft_order.shipping_address.country
        };

        const params = new URLSearchParams(thankyou_obj).toString();
        window.location.href = `/pages/thank-you?${params}`;
      }
    })
    .catch(err => console.error(err));
  }
});
    
      
      document.getElementById('go_next_step')?.addEventListener('click', async function () {
        const fields = document.querySelectorAll('.step_form_row input, .step_form_row select');
        let hasError = false;
      
        fields.forEach(field => {
          const error = field.nextElementSibling;
      
          if (error && error.classList.contains('error-msg')) {
            error.remove();
            field.classList.remove('error_input');
          }


          if(!terms_service?.checked && terms_service_label) {
            terms_service_label.classList.add('error_input');
            hasError = true;
          }
          
      
          if (!field.value.trim() && field.dataset.error) {
            hasError = true;
            const errorMsg = field.dataset.error;
            const errorSpan = document.createElement('span');
            errorSpan.classList.add('error-msg');
            errorSpan.textContent = errorMsg;
            field.insertAdjacentElement('afterend',errorSpan);
            field.classList.add('error_input');
          }
        });
      
        if (!hasError) {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          initializeCountdown('.c-countdown', 15);     

          const step_1 = document.querySelectorAll('.step_1');
          step_1?.forEach(block => {
            block.classList.add('hidden');
          });

          const step_2 = document.querySelectorAll('.step_2');
          step_2?.forEach(block => {
            block.classList.add('active');
          });
          }
      });

      document.querySelectorAll('.step_form_row input, .step_form_row select')?.forEach(el => {
        el.addEventListener("change", handleChangeInputs);
      });

      document.querySelectorAll('.step_form_row input, .step_form_row select')?.forEach(field => {
        field.addEventListener('input', () => {
          const error = field.nextElementSibling;
          if (error && error.classList.contains('error-msg')) {
            error.remove();
            field.classList.remove('error_input');
          }
        });
    });
  }

    function handleChangeInputs_OLD() {
        const fields = document.querySelectorAll('.step_form_row input, .step_form_row select');
        let hasError = false;
        let formData = {};
        const pendingDraft = localStorage.getItem("pendingDraft");

      
        fields.forEach(field => {
      
          if (!field.value.trim()) {
            hasError = true;
          } else {
          formData[field.name] = field.value.trim();
    
          const checkstate = field.dataset.checkstate;
          if(checkstate) {
          const selectedOption = field.options[field.selectedIndex];
            formData['state'] = selectedOption.dataset.state;
          }
        }
        });
      
        if (!hasError && pendingDraft == null) {
          formData['note'] = "Temporary Draft Step 1";
          formData['id'] = null;
          formData['step_1'] = true;
          formData['email'] = generateEmail(formData['lastName'],formData['phone']);
          // return;
          fetch('https://knee-lap-app-69bcb28b7052113be9cf.o2.myshopify.dev/create-orderv2', {
            method: 'POST',
            body: JSON.stringify(formData),
          })
          .then(res => res.json())
          .then(data => {
            if(data.success) {
              const draft_order = data.data.draft_order;
              if (draft_order?.id) {
                localStorage.setItem("pendingDraft", draft_order.id);
                localStorage.setItem("pendingDraftData", JSON.stringify(formData));
              }
            }
          })
          .catch(err => console.error(err));
          
        } else if (!hasError && pendingDraft) {
          formData['id'] = pendingDraft;
          formData['step_1'] = true;
          formData['email'] = generateEmail(formData['lastName'],formData['phone']);
          // return;
          fetch('https://knee-lap-app-69bcb28b7052113be9cf.o2.myshopify.dev/create-orderv2', {
            method: 'POST',
            body: JSON.stringify(formData),
          })
          .then(res => res.json())
          .then(data => {
            if(data.success) {
              const draft_order = data.data.draft_order;
              if (draft_order?.id) {
                localStorage.setItem("pendingDraftData", JSON.stringify(formData));
              }
            }
          })
          .catch(err => console.error(err));
          
        } else {
          console.log("NO");

        }
    }

  function handleChangeInputs() {
  const fields = document.querySelectorAll('.step_form_row input, .step_form_row select');
  let hasError = false;
  let formData = {};
  const pendingDraft = localStorage.getItem("pendingDraft");

  fields.forEach(field => {
    if (!field.value.trim()) {
      hasError = true;
    } else {
      formData[field.name] = field.value.trim();

      const checkstate = field.dataset.checkstate;
      if(checkstate) {
        const selectedOption = field.options[field.selectedIndex];
        formData['state'] = selectedOption.dataset.state;
      }
    }
  });

  if (!hasError) {
    // Add common fields
    formData['note'] = "Temporary Draft Step 1";
    formData['step_1'] = true;
    formData['email'] = generateEmail(formData['lastName'], formData['phone']);
    
    // If updating existing draft, add rowId
    if (pendingDraft) {
      formData['rowId'] = pendingDraft; // Changed from 'id' to 'rowId'
    }

    fetch(appsScriptUrl, {
      method: 'POST',
      body: JSON.stringify(formData),
    })
    .then(res => res.json())
    .then(data => {
      if(data.status === 'success') {
        if (data?.rowId) { // Fixed: was data.row_id
          localStorage.setItem("pendingDraft", data.rowId); // Fixed: was data.row_id
          localStorage.setItem("pendingDraftData", JSON.stringify(formData));
        }
      }
    })
    .catch(err => console.error(err));
    
  } else {
    console.log("Form has errors");
  }
}

  function generateEmail(name, phone) {
    const sanitizedName = name.trim().toLowerCase().replace(/\s+/g, '_');
    const sanitizedPhone = phone.replace(/\D/g, '').slice(-6);
    return `kneelab+${sanitizedName}_${sanitizedPhone}@gmail.com`;
  }

  function moveBlocks () {
    if (innerWidth < 768) {
      const form_to_submit = document.getElementById('form_to_submit');
      const shipping_info = document.getElementById('shipping_info');
      const parent = document.querySelector('#second_column .c-product__block');
      parent.insertBefore(form_to_submit,shipping_info);
    }
  }

  function getShipToOrderSummary() {
    const radios = document.querySelectorAll('.c- .c-product__option-control');

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          const item = radio.closest('.c-product__option');
          const ship = item.querySelector('.c-product__free-ship').textContent;
          const title = item.querySelector('.c-product__option-title').textContent;
          const formattedTitle = title.replace(/(\d+\s+Par(?:es)?)/g, '<span>$1</span>');
          

          const productOrderSummaryShip = document.querySelector('.c-order-summary__free-ship');
          if (productOrderSummaryShip) {
            productOrderSummaryShip.textContent = ship;
          }

          const productTitleEl = document.querySelector('.js-product-title');
          if (productTitleEl) {
            productTitleEl.innerHTML = formattedTitle;
          }
        }
      });
    });
  }    

  function initInputValues () {
    const pendingDraft = localStorage.getItem("pendingDraft");
    const pendingDraftData = localStorage.getItem("pendingDraftData");

    if (pendingDraft && pendingDraftData) {
      const data = JSON.parse(pendingDraftData);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = document.querySelector(`[name="${key}"]`);
          if (element) {
            if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
              element.value = data[key];
            } else if (element.tagName === "SELECT") {
              element.value = data[key];
            }
          }
        }
      }
    }


  }

  // load
   window.addEventListener('load', () => {
      getSeason();
      getSeasonCheckout();
      showDeal(); 
      getgGeoShipping();
      autoClickToCheckout();   
      toggleOrderSummary();
      getShipToOrderSummary();
      initProduct();
      initProductCountStock();      
      initAdditionalProductCheckbox();
      initCreateOrder();
      initInputValues();
      // moveBlocks();
  });
  
})();